import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import Loader from '../../../UI/Loading'
import config from '../../../../config'
import DELETE_FILE_QUERY from '../../../../graphql/DeleteFile.graphql'
import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourPhotos.graphql'
import ImgBankPhotoSelectionModal from '../../../ImgBankPhotoSelection/ImgBankPhotoSelectionModal'
import { NotificationManager } from 'react-notifications'

class PhotosForm extends React.Component {
  state = {
    saving: false,
    photos: []
  }

  componentDidMount() {
    let photos = []
    if (this.props.currentSteps.photos && this.props.currentSteps.photos.length < 3) {
      photos = [...this.state.photos]

      this.props.currentSteps.photos.forEach((photo, index) => {
        photos.push(photo)
      })
      for (let i = 0; i < 3 - this.props.currentSteps.photos.length; i++) {
        photos.push({})
      }
    } else if (this.props.currentSteps.photos && this.props.currentSteps.photos.length === 3) {
      photos = this.props.currentSteps.photos
    } else {
      photos = [{}, {}, {}]
    }

    this.setState({
      photos: photos
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentSteps.photos && nextProps.currentSteps.photos.length) {
      this.setState({
        photos: nextProps.currentSteps.photos
      })
    }
  }

  checkPhotos = photos => photos.filter(photo => !!photo.src)

  handleSubmit = () => {
    const { data, updateLocalTour, currentSteps } = this.props
    this.setState({
      saving: true
    })

    if (!!this.checkPhotos(this.state.photos).length) {
      let promises = this.state.photos
        .filter(photo => {
          return !photo.id && photo.name
        })
        .map(file => {
          return new Promise((resolve, reject) => {
            let data = new FormData()
            data.append('data', file)
            resolve(
              fetch(config.fileAPI, {
                method: 'POST',
                body: data
              })
            )
          }).then(res => res.json())
        })

      Promise.all(promises)
        .then(result => {
          return result.map(file => file.id)
        })
        .then(fileIds => {
          let photosIds = this.state.photos.filter(photo => photo.id).map(photo => photo.id)

          fileIds.forEach(id => {
            photosIds.push(id)
          })

          this.setState({
            photosIds: photosIds
          })

          this.props.updateSteps()

          return updateLocalTour({
            variables: {
              id: currentSteps.id,
              photosIds: photosIds
            }
          })
        })
        .then(() => {
          NotificationManager.success('Photos updated', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            this.props.history.push(`/activity-steps/${data.allLocalTours[0].id}/what-will-do`)
          } else {
            this.props.history.push('/activity-steps/what-will-do')
          }
        })
        .catch(err => NotificationManager.error('Error while updating photos', 'Error', 5000))
    } else {
      this.setState({
        vlidationError: 'Must have at least one photo',
        saving: false
      })
    }
  }

  handleChange(e, index) {
    let photos = [...this.state.photos]

    photos[index] = e[0]
    let reader = new FileReader()
    reader.onload = function(e) {
      photos[index].src = e.target.result

      this.setState({
        photos: photos
      })
    }.bind(this)

    reader.readAsDataURL(e[0])
  }

  removePhoto = (e, index) => {
    let photos = [...this.state.photos]

    if (photos[index].id) {
      this.props
        .deleteFile({
          variables: {
            id: photos[index].id
          }
        })
        .then(() => {
          photos[index] = {}

          this.setState(
            {
              photos: photos
            },
            () => {
              this.props.updateSteps()
            }
          )
        })
    } else {
      photos[index] = {}

      this.setState(
        {
          photos: photos
        },
        () => {
          this.props.updateSteps()
        }
      )
    }
  }

  closeModal = index => {
    const imgModal = {}
    imgModal['imgModal' + index] = false
    this.setState(imgModal)
  }

  render() {
    if (this.props.loading) {
      return <Loader showLoader={true} />
    }
    const { t, data } = this.props
    const { saving } = this.state

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('add_photos')}</div>
        <div className="form-subtitle-bold">{t('quality_photos')}</div>
        <div className="form-subtitle-last">{t('chance_picked')}</div>
        <div className="steps-screen__form-input-area photos__form">
          {this.state.photos.map((photo, index) => (
            <div className="photo-upload" key={index}>
              <div className={photo.url || photo.src ? 'hidden' : 'photo-wrapper'}>
                <div
                  className="missing-photo"
                  onClick={e => {
                    let imgModal = {}
                    imgModal['imgModal' + index] = true
                    this.setState(imgModal)
                  }}
                >
                  <i className="icon-plus" />
                </div>

                <ImgBankPhotoSelectionModal
                  id={'file' + index}
                  user={data.user}
                  isOpen={this.state['imgModal' + index]}
                  index={index}
                  onClose={this.closeModal}
                  onFileChange={e => this.handleChange(e, index)}
                  t={t}
                />
              </div>

              <div className={photo.url || photo.src ? 'photo-upload__image-wrapper' : 'hidden'}>
                <img src={photo.url || photo.src} alt="" className={photo.url || photo.src ? 'photo-upload__image' : 'hidden'} />
                <button disabled={saving} className="photo-upload__remove-btn" onClick={e => this.removePhoto(e, index)}>
                  <i className="icon-plus" />
                  {t('main:remove')}
                </button>
              </div>
            </div>
          ))}
          <div>Please select at least one picture.</div>
        </div>
        <small className="text-danger">{this.state.vlidationError}</small>
        <button onClick={() => this.handleSubmit()} className="btn btn-lg btn-primary btn-danger">
          {t('main:save_continue')}
        </button>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(DELETE_FILE_QUERY, {
    name: 'deleteFile'
  }),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(PhotosForm)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MainInfo/PhotosForm.jsx